<template>
  <div style="margin:1%">
    <b-row align-v="end" align-h="start">
      <b-col cols="2">
        <md-button @click.stop="addTariffLink" class="md-raised">{{ $t('Add') }}</md-button>
      </b-col>
      <b-col cols="2">
        <md-field>
          <label for="curCustomers">{{$t('Select account')}}</label>
          <md-select v-model="selectedAccount">
            <md-option v-for="item in currentRow.accounts" :key="item" :value="item"> {{ item }} </md-option>
          </md-select>
        </md-field>
      </b-col>
      <b-col cols="2">
        <md-button class="md-raised" @click="$refs.TLHistory.show()" style="margin-top:0px">{{ $t('History') }}</md-button>
      </b-col>
    </b-row>
    <b-table
    ref="tableTariffLinks"
    small
    striped
    hover
    :items="tariffLinks"
    :fields="tariffLinksFields"
    @row-clicked="rowTariffLinkClickHandler"
    @row-dblclicked="rowTariffLinkDblClickHandler">

       <template v-slot:cell(actions)="row">
        <i @click.stop="ClickOnEditTariffButton(row)" class="primary fa fa-edit fa-lg" />
        <i @click.stop="ClickOnDeleteTariffButton(row)" class="danger fa fa-trash-alt fa-lg" />
      </template>
    </b-table>

    <b-modal size="xl" ref="tariffLink" hide-footer :title="$t('Tariff link details')">
      <b-form-group label-align="right" :label="$t('Current tariff plan')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-select :options="listOfTariffs" v-model="selectedTariffs" :disabled="isEdit"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Next tariff plan')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-select :options="listOfNextTariffs" v-model="newTariff.second_tariff_id"/>
          <b-input-group-append>
            <md-button v-if="isEdit" class="md-raised" @click="checkTarifflinkNow" style="margin-top:0rem">{{ $t('Change now') }}</md-button>
          </b-input-group-append>
          <b-input-group-append  v-if="isEdit">
            <flat-picker :class="dateClass"
            @onDateChanged="onChangedDateStart"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(this.currentRowTariffLink.change_date ? this.currentRowTariffLink.change_date : new Date()/1000 ).toDate())}"
            style="margin-left:0.3rem"></flat-picker>
          <i class="primary fa fa-light fa-exclamation fa-lg"
          v-b-tooltip.hover :title="$i18n.t('tooltip_flatpicker')"
          style="margin-left:0.1rem;margin-right:0.2rem;margin-top:0.65rem"/>

          </b-input-group-append>
          <b-input-group-append>
            <md-button v-if="isEdit" class="md-raised" @click="onSchedule" style="margin-top:0rem">{{ $t('Schedule') }}</md-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="selectAccountingPeriod.length > 0" :placeholder="$t('Tap to select')"/>
          <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit" />
          <b-form-invalid-feedback id="inputFeedback">
            {{ $t('Select accounting period') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Next accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group >
          <b-form-input type="text" disabled v-model="selectNewAccountingPeriod" aria-describedby="inputFeedback" :placeholder="$t('Tap to select')"/>
          <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="$refs.newAccoutingPeriod.show()" />
        </b-input-group>
      </b-form-group>
      <b-form-group v-if="isEdit && selectedTariffs !== 0" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <md-button class="md-raised" @click="showServiceLink" >{{ $t('Create service link') }}</md-button>
      </b-form-group>

      <b-row>
        <b-col cols="5">
        </b-col>
        <b-col cols="6">
          <b-row>
            <b-col cols="6">
              <md-button @click.stop="hideTariffLink"  >{{ $t('Cancel') }}</md-button>
            </b-col>
            <b-col cols="6">
              <md-button @click.stop="checkTarifflink" class="md-raised">{{ $t('Save') }}</md-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="warning" hide-footer :title="$t('Warning')">
      <p>{{ $t('Next tariff plan contains services. Are you sure you want to use it?') }}</p>
      <modal-ok-cancel @save="saveTarifflink" @cancel="hideWarning" buttonSaveLabel="Ok"/>
    </b-modal>

    <b-modal ref="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="newTariff.accounting_period_id"
        @hideAccoutingPeriod="hideAccoutingPeriod"/>
    </b-modal>

    <b-modal ref="newAccoutingPeriod" id="newAccoutingPeriod" hide-footer :title="$t('New accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="newTariff.new_accounting_period_id"
        @hideAccoutingPeriod="$bvModal.hide('newAccoutingPeriod')"/>
    </b-modal>

    <b-modal hide-footer ref="modalOneTime" :title="$t('One-time service link')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowOneTime = false" @show="isShowOneTime = true">
      <FormOneTime v-if="isShowOneTime"
      @hideSelectService="hideOneTime"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"/>
    </b-modal>

    <b-modal hide-footer ref="modalPeriodic" :title="$t('Periodic service link')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowPeriodic = false" @show="isShowPeriodic = true" size="lg">
      <FormPeriodic id="formPeriodic" v-if="isShowPeriodic"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      :currentUser="currentRow"
      :currentService="currentService"
      @hideSelectService="hidePeriodic"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalIPTraffic" :title="$t('IP traffic service link')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowTPTraffic = false" @show="isShowTPTraffic = true" size="lg">
      <FormIPTraffic v-if="isShowTPTraffic"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideIPTraffic"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalHotspot" :title="$t('Hotspot service link')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowHotspot = false" @show="isShowHotspot = true" size="lg">
      <FormHotspot v-if="isShowHotspot"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideHotspot"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalDialup" :title="$t('Dial-up service link')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowDialup = false" @show="isShowDialup = true" size="lg">
      <FormDialup v-if="isShowDialup"
      :listOfChargePolicy="listOfChargePolicy"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      @hideSelectService="hideDialup"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalTelephony" :title="$t('Telephony service link')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowTelephony = false" @show="isShowTelephony = true" size="lg">
      <FormTelephony v-if="isShowTelephony"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideTelephony"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalIPTV" :title="$t('IPTV service link')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowIPTV = false" @show="isShowIPTV = true">
      <FormIPTV v-if="isShowIPTV"
      :listOfCoefficientScheme="listOfCoefficientScheme"
      :listOfChargePolicy="listOfChargePolicy"
      @hideSelectService="hideIPTV"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalVideo" :title="$t('Video on demand')+' ('+this.currentService.service_name+' ['+this.currentService.service_id+']'+')'" @hidden="isShowVideo = false" @show="isShowVideo = true">
      <FormVideo v-if="isShowVideo"
      @hideSelectService="hideVideo"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"/>
    </b-modal>

   <b-modal hide-footer :title="$t('Select service')" id="modalServiceLinks" ref="modalServiceLinks">
    <b-table small striped hover
      :items="serviceLinks"
      :fields="serviceLinksFields"
      selectable
      @row-selected="onRowSelected"
      select-mode="single"/>
      <modal-ok-cancel @save="selectServiceLink" @cancel="$bvModal.hide('modalServiceLinks')" buttonSaveLabel="Ok"/>
   </b-modal>

    <b-modal hide-footer  ref="TLHistory" :title="$t('Tariff links history')">
      <History :acc_id="selectedAccount"/>
    </b-modal>
  </div>
</template>

<script>
import FormAccountinfPeriod from '../serviceLinks/formAccountingPeriod'
import FormOneTime from '@/pages/users/usersAndGroups/detail/serviceLinks/formOnce.vue'
import FormPeriodic from '@/pages/users/usersAndGroups/detail/serviceLinks/formPeriodic.vue'
import FormIPTraffic from '@/pages/users/usersAndGroups/detail/serviceLinks/formIPTraffic.vue'
import FormHotspot from '@/pages/users/usersAndGroups/detail/serviceLinks/formHotspot.vue'
import FormDialup from '@/pages/users/usersAndGroups/detail/serviceLinks/formDialup.vue'
import FormTelephony from '@/pages/users/usersAndGroups/detail/serviceLinks/formTelephony.vue'
import FormIPTV from '@/pages/users/usersAndGroups/detail/serviceLinks/formIPTV.vue'
import FormVideo from '@/pages/users/usersAndGroups/detail/serviceLinks/formVOD.vue'
import History from './history.vue'
import moment from 'moment'
export default {
  components: {
    FormAccountinfPeriod,
    FormOneTime,
    FormPeriodic,
    FormIPTraffic,
    FormHotspot,
    FormDialup,
    FormTelephony,
    FormIPTV,
    FormVideo,
    History
  },
  props: {
    listOfCoefficientScheme: null,
    listOfChargePolicy: null,
    currentRow: null
  },
  data () {
    return {
      servicesUser: null,
      selectedServiceLink: null,
      serviceLinks: [],
      serviceLinksFields: [
        { key: 'service_id', label: this.$i18n.t('Service ID'), sortable: true },
        { key: 'service_name', label: this.$i18n.t('Service name'), sortable: true },
        { key: 'nameServicesType', label: this.$i18n.t('Service type'), sortable: true },
        { key: 'comment', label: this.$i18n.t('Comments'), sortable: true }
      ],
      listServices: [],
      isEdit: false,
      isShowOneTime: false,
      isShowPeriodic: false,
      isShowTPTraffic: false,
      isShowHotspot: false,
      isShowDialup: false,
      isShowTelephony: false,
      isShowIPTV: false,
      isShowVideo: false,
      selectedTariffs: 0,
      newTariff: {
        'user_id': 0,
        'account_id': 0,
        'first_tariff_id': 0,
        'second_tariff_id': 0,
        'accounting_period_id': 0,
        'new_accounting_period_id': 0,
        'tariff_link_id': 0,
        'change_now': false
      },
      emptyTariff: {
        'user_id': 0,
        'account_id': 0,
        'first_tariff_id': 0,
        'second_tariff_id': 0,
        'accounting_period_id': 0,
        'new_accounting_period_id': 0,
        'tariff_link_id': 0,
        'change_now': false
      },
      selectedAccount: null,
      tariffPlan: [],
      tariffLinksFields: [
        { key: 'id', label: this.$i18n.t('Tlink ID'), sortable: true },
        { key: 'current_tariff_id', label: this.$i18n.t('Current TP ID'), sortable: true },
        { key: 'current_tariff_name', label: this.$i18n.t('Current tariff plan'), sortable: true },
        { key: 'next_tariff_id', label: this.$i18n.t('Next TP ID'), sortable: true },
        { key: 'next_tariff_name', label: this.$i18n.t('Next tariff plan'), sortable: true },
        { key: 'accounting_period_id', label: this.$i18n.t('Accounting period'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      currentRowTariffLink: {
        'user_id': 0,
        'account_id': 0,
        'first_tariff_id': 0,
        'second_tariff_id': 0,
        'accounting_period_id': 0,
        'new_accounting_period_id': 0,
        'tariff_link_id': 0,
        'change_now': false
      },
      tariffLinkId: 0,
      accountingPeriodId: 0,
      currentService: {
        service_id: 0,
        service_name: ''
      },
      currentServiceInTariff: -1,
      currentScheduledDate: this.$root.getMomentWithOutTZDelta(moment().unix()).unix()
    }
  },
  methods: {
    onSchedule () {
      if (this.currentScheduledDate < this.$root.getMomentWithTZDelta(moment().unix()).unix()) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('It is forbidden to set data with expiry date earlier than the current one'), 'Error')
        return
      }
      this.newTariff.change_date = this.currentScheduledDate
      this.newTariff.change_now = false
      this.checkTarifflink()
    },
    onChangedDateStart (unixDate) {
      this.currentScheduledDate = this.$root.getMomentWithOutTZDelta(unixDate).unix()
    },
    ClickOnDeleteTariffButton (row) {
      this.tariffPlan = row.item
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Tariff links"?'), this.deleteTariff, row.item)
    },
    deleteTariff () {
      if (this.tariffPlan) {
        let payload = {
          user_id: this.currentRow.user_id,
          account_id: this.selectedAccount,
          tplink_id: this.tariffPlan.id
        }
        let response = this.$store.dispatch('Users/DELETE_USER_TARIFF_LINKS', payload)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            let payload = {
              user_id: this.currentRow.user_id,
              account_id: this.selectedAccount
            }
            this.$store.dispatch('Users/GET_USER_TARIFF_LINKS', payload)
            this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
            this.$root.$emit('makeToasts')
          }
        })
      }
    },
    addTariffLink () {
      this.isEdit = false
      this.newTariff = {
        'user_id': 0,
        'account_id': 0,
        'first_tariff_id': 0,
        'second_tariff_id': 0,
        'accounting_period_id': 0,
        'new_accounting_period_id': 0,
        'tariff_link_id': 0,
        'change_now': false
      }
      this.$set(this.newTariff, 'new_accounting_period_id', 0)
      this.showTariffLink()
    },
    fillNewTariff (item) {
      this.newTariff.account_id = this.selectedAccount
      this.newTariff.user_id = this.currentRow.user_id
      this.newTariff.second_tariff_id = item.next_tariff_id
      this.newTariff.first_tariff_id = item.current_tariff_id
      this.newTariff.accounting_period_id = item.accounting_period_id
      this.newTariff.new_accounting_period_id = item.new_accounting_period_id
      this.newTariff.tariff_link_id = item.id
      this.newTariff.change_now = false
      this.newTariff.change_date = item.change_date
    },
    editTariffLink (item) {
      this.isEdit = true
      this.currentRowTariffLink = item
      this.currentScheduledDate = item.change_date
      this.fillNewTariff(item)
      this.showTariffLink()
    },
    ClickOnEditTariffButton (row) {
      this.editTariffLink(row.item)
    },
    rowTariffLinkDblClickHandler (item) {
      this.editTariffLink(item)
    },
    rowTariffLinkClickHandler (row) {
      if (this.currentRowTariffLink) {
        this.currentRowTariffLink._rowVariant = ''
      }
      this.currentRowTariffLink = row
      this.$set(this.currentRowTariffLink, '_rowVariant', 'info')
    },
    async showTariffLink () {
      this.newTariff.change_now = false
      if (this.isEdit) {
        this.selectedTariffs = this.currentRowTariffLink.current_tariff_id
      }
      this.$refs.tariffLink.show()
    },
    hideTariffLink () {
      this.newTariff = JSON.parse(JSON.stringify(this.emptyTariff))

      this.$refs.tariffLink.hide()
      this.isEdit = false
    },
    showWarning () {
      this.$refs.warning.show()
    },
    hideWarning () {
      this.newTariff.change_now = false
      this.$refs.warning.hide()
    },
    showFormAccountingPeriod () {
      this.$refs.accoutingPeriod.show()
    },
    hideAccoutingPeriod () {
      this.$refs.accoutingPeriod.hide()
    },
    checkTarifflinkNow () {
      this.newTariff.change_now = true
      this.checkTarifflink()
    },
    checkTarifflink () {
      this.newTariff.new_accounting_period_id = this.newTariff.new_accounting_period_id ? this.newTariff.new_accounting_period_id : this.currentRowTariffLink.new_accounting_period_id
      if (this.isEdit) {
        this.newTariff.accounting_period_id = this.currentRowTariffLink.accounting_period_id
        this.newTariff.tariff_link_id = this.currentRowTariffLink.id
      } else {
        if (!this.newTariff.accounting_period_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
          return
        }
      }
      this.newTariff.user_id = this.currentRow.user_id
      this.newTariff.account_id = this.selectedAccount
      this.newTariff.first_tariff_id = this.selectedTariffs
      if (this.newTariff.second_tariff_id === 0) {
        this.newTariff.second_tariff_id = this.newTariff.first_tariff_id
      } else {
        this.newTariff.second_tariff_id = this.newTariff.second_tariff_id
      }
      if (this.newTariff.second_tariff_id !== this.newTariff.first_tariff_id) {
        let isFirst = this.$store.getters['Tariffing/TARIFFS'].find(el => {
          return el.id === this.newTariff.first_tariff_id
        })
        let isSecond = this.$store.getters['Tariffing/TARIFFS'].find(el => {
          return el.id === this.newTariff.second_tariff_id
        })
        if (isFirst.services.length === isSecond.services.length) {
          let isFound = false
          for (let i in isFirst.services) {
            isFound = false
            for (let j in isSecond.services) {
              if (isFirst.services[i].parent_id === isSecond.services[j].parent_id) {
                isFound = true
                break
              }
            }
            if (!isFound) {
              this.showWarning()
              break
            }
          }
          if (isFound) {
            this.saveTarifflink()
          }
        } else {
          this.showWarning()
        }
      } else {
        this.saveTarifflink()
      }
    },
    async saveTarifflink () {
      this.$refs.warning.hide()
      let response = this.$store.dispatch('Users/CREATE_USER_TARIFF_LINKS', this.newTariff)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.tariffLinkId = response.data.tariff_link_id
          this.accountingPeriodId = this.newTariff.accounting_period_id
          let payload = {
            user_id: this.currentRow.user_id,
            account_id: this.selectedAccount,
            tariff_link_id: response.data.tariff_link_id
          }
          this.$store.dispatch('Users/GET_SERVICES_IN_TARIFF_LINK', payload).then(response => {
            this.listServices = JSON.parse(JSON.stringify(this.$store.getters['Users/SERVICES_IN_TARIFF_LINK']))
            if (!this.isEdit) {
              this.openNextServiceInTariff()
            }
            this.$root.$emit('makeToasts')
            let payload = {
              user_id: this.currentRow.user_id,
              account_id: this.selectedAccount
            }
            this.$store.dispatch('Users/GET_USER_TARIFF_LINKS', payload)
            this.hideTariffLink()
          })
        }
      })
    },
    showPeriodic () {
      this.$refs.modalPeriodic.show()
    },
    hidePeriodic () {
      this.$refs.modalPeriodic.hide()
      this.openNextServiceInTariff()
    },
    showOneTime () {
      this.$refs.modalOneTime.show()
    },
    hideOneTime () {
      this.$refs.modalOneTime.hide()
      this.openNextServiceInTariff()
    },
    showHotspot () {
      this.$refs.modalHotspot.show()
    },
    hideHotspot () {
      this.$refs.modalHotspot.hide()
      this.openNextServiceInTariff()
    },
    showDialup () {
      this.$refs.modalDialup.show()
    },
    hideDialup () {
      this.$refs.modalDialup.hide()
      this.openNextServiceInTariff()
    },
    showTelephony () {
      this.$refs.modalTelephony.show()
    },
    hideTelephony () {
      this.$refs.modalTelephony.hide()
      this.openNextServiceInTariff()
    },
    showIPTraffic () {
      this.$refs.modalIPTraffic.show()
    },
    hideIPTraffic () {
      this.$refs.modalIPTraffic.hide()
      this.openNextServiceInTariff()
    },
    showIPTV () {
      this.$refs.modalIPTV.show()
    },
    hideIPTV () {
      this.$refs.modalIPTV.hide()
      this.openNextServiceInTariff()
    },
    showVideo () {
      this.$refs.modalVideo.show()
    },
    hideVideo () {
      this.$refs.modalVideo.hide()
      this.openNextServiceInTariff()
    },
    async openNextServiceInTariff () {
      if (++this.currentServiceInTariff < this.listServices.length) {
        let tmpService = this.listServices[this.currentServiceInTariff]
        if (tmpService.link_by_default === 1) {
          this.currentService.addByDefault = true
        } else {
          this.currentService.addByDefault = false
        }

        this.currentService.service_id = tmpService.service_id
        this.currentService.service_name = tmpService.service_name
        this.currentService.policy_id = tmpService.policy_id
        this.currentService.scheme_id = tmpService.scheme_id
        switch (tmpService.service_type) {
          case 1:
            this.showOneTime()
            break
          case 2:
            this.showPeriodic()
            break
          case 3:
            this.showIPTraffic()
            break
          case 4:
            this.showHotspot()
            break
          case 5:
            this.showDialup()
            break
          case 6:
            this.showTelephony()
            break
          case 8:
            this.showIPTV()
            break
          case 9:
            this.showVideo()
            break
        }
        // }
      } else {
        this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
      }
    },
    onRowSelected (selected) {
      this.selectedServiceLink = selected[0]
    },
    async showServiceLink () {
      this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount).then(response => {
        this.servicesUser = JSON.parse(JSON.stringify(this.$store.getters['Users/USER_SERVICES_LINKS_ACC']))
        this.serviceLinks = []
        this.selectedServiceLink = null
        let tariffId = this.selectedTariffs
        let servicesuser = []
        let services = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))
        this.serviceLinks = services.filter(function (value) {
          return value.tariff_id === tariffId
        })
        for (let el of this.servicesUser) {
          for (let elServices of services) {
            if (el.service_id === elServices.service_id) {
              servicesuser.push(elServices)
            }
          }
        }
        for (let el of servicesuser) {
          this.serviceLinks = this.serviceLinks.filter(function (value) {
            return (value.parent_id !== el.parent_id || value.multiple_linking)
          })
        }
        for (let el of this.serviceLinks) {
          switch (el.service_type) {
            case 1:
              el.nameServicesType = this.$i18n.t('One-time service link')
              break
            case 2:
              el.nameServicesType = this.$i18n.t('Periodic service link')
              break
            case 3:
              el.nameServicesType = this.$i18n.t('IP traffic service link')
              break
            case 4:
              el.nameServicesType = this.$i18n.t('Hots pot service link')
              break
            case 5:
              el.nameServicesType = this.$i18n.t('Dial-up service link')
              break
            case 6:
              el.nameServicesType = this.$i18n.t('Telephony service link')
              break
            case 8:
              el.nameServicesType = this.$i18n.t('IPTV service link')
              break
            case 9:
              el.nameServicesType = this.$i18n.t('Video service link')
              break
          }
        }
        this.$refs.modalServiceLinks.show()
      })
    },
    selectServiceLink () {
      if (!this.selectedServiceLink) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }

      this.accountingPeriodId = this.currentRowTariffLink.accounting_period_id
      this.currentServiceInTariff = -1
      this.listServices = []
      this.listServices.push(this.selectedServiceLink)
      this.openNextServiceInTariff()
      this.$refs.modalServiceLinks.hide()
    }
  },
  watch: {
    selectedAccount: function () {
      let payload = {
        user_id: this.currentRow.user_id,
        account_id: this.selectedAccount
      }
      this.$store.dispatch('Users/GET_USER_TARIFF_LINKS', payload)
    }
  },
  mounted () {
    this.selectedAccount = this.currentRow.accounts[0]
  },
  computed: {
    dateClass () {
      if (this.currentRowTariffLink.change_date > moment().unix()) {
        return 'shadow p-0 mb-3 bg-danger'
      }
    },
    tariffLinks () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Users/USER_TARIFF_LINKS']))
      for (let el of copy) {
        for (let elTariff of this.$store.getters['Tariffing/TARIFFS']) {
          if (el.current_tariff_id === elTariff.id) {
            el.current_tariff_name = elTariff.name
          }
          if (el.next_tariff_id === elTariff.id) {
            el.next_tariff_name = elTariff.name
          }
        }
      }
      return copy
    },
    listOfTariffs () {
      let tmp = [
        {value: 0, text: this.$i18n.t('Empty tariff by default')}
      ]
      let tariffs = this.$store.getters['Tariffing/TARIFFS'].filter(el => { return el.id !== 0 })
      for (let el of tariffs) {
        let newEl = {
          value: el.id,
          text: el.name + ' (' + el.id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    listOfNextTariffs () {
      let tmp = [
        {value: 0, text: this.$i18n.t('Do not change')}
      ]
      let tariffs = this.$store.getters['Tariffing/TARIFFS'].filter(el => { return el.id !== 0 })
      for (let el of tariffs) {
        let newEl = {
          value: el.id,
          text: el.name + ' (' + el.id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    selectAccountingPeriod () {
      let tmp = ''
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
        if (this.isEdit) {
          if (el.id === this.currentRowTariffLink.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            tmp = el.begin + ' / ' + el.end + ' (' + el.id + ')'
            return tmp
          }
        } else {
          if (el.id === this.newTariff.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            tmp = el.begin + ' / ' + el.end + ' (' + el.id + ')'
            return tmp
          }
        }
      }
      return tmp
    },
    selectNewAccountingPeriod () {
      let tmp = ''
      let nAPID = this.newTariff.new_accounting_period_id ? this.newTariff.new_accounting_period_id : this.currentRowTariffLink.new_accounting_period_id
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
        if (el.id === nAPID) {
          el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
          el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
          tmp = el.begin + ' / ' + el.end + ' (' + el.id + ')'
          return tmp
        }
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/tariffLinks/main.vue